<template>
  <va-card title="留学导师列表">
    <div class="row align--center mb-1">
      <div class="flex xs12 sm6">
        <va-input
          class="ma-0"
          :value="term"
          placeholder="search by name"
          @input="search"
          removable
        >
          <va-icon name="fa fa-search" slot="prepend"/>
        </va-input>
      </div>
      <div class="flex xs12 sm6">
        <div class="d-flex justify--end">
          <va-button color="info" small :to="{ name: 'saveMentor' }">新增留学导师</va-button>
        </div>
      </div>
    </div>
    <va-data-table
      :fields="fields"
      :data="filteredData"
      :loading="loading"
      :totalPages="totalPages"
      @page-selected="listMentor"
      api-mode
    >
      <template slot="avatar" slot-scope="props">
        <img :src="props.rowData.avatar" class="data-table-server-pagination---avatar" alt="avatar">
      </template>

      <template slot="enterpriseLogo" slot-scope="props">
        <img :src="props.rowData.enterpriseLogo" class="data-table-server-pagination---avatar" alt="avatar">
      </template>

      <template slot="sort" slot-scope="props">
        <va-input
          v-model="props.rowData.sortNum"
          type="number"
          :min="1"
        >
          <va-button slot="append" icon="ion-md-checkmark ion" color="info" small @click="updateSortNum(props.rowData)">
          </va-button>
        </va-input>
      </template>
      <template slot="actions" slot-scope="props">
        <va-button flat small color="gray" icon="fa fa-pencil"
          :to='{path:`updateMentor/${props.rowData.id}`}'/>
        <va-button flat small color="gray" icon="fa fa-trash"
          @click="deleteMentorModal = true;deleteId=props.rowData.id"/>
      </template>
    </va-data-table>
    <va-modal
      v-model="deleteMentorModal"
      title="删除留学导师"
      okText="提交"
      position="center"
      message="请再次确认是否要删除？"
      @ok="confirmDeleteMentor"
    />
  </va-card>
</template>

<script>

import mentorApi from '../../../api/liuxue/mentor.js'
import uploadApi from '../../../api/upload'
import debounce from 'lodash/debounce'

export default {
  data () {
    return {
      pageSize: 10,
      totalPages: 0,
      items: [],
      loading: true,
      updateMentorModal: false,
      deleteMentorModal: false,
      updateData: {
        id: 1,
        name: '',
        avatar: '',
        mentorAvatar: [],
        position: '',
        enterpriseLogo: '',
        enterpriseLogoFile: [],
        experience: '',
        sortNum: '',
        active: null,
        strength: '',
      },
      deleteId: null,
      messages: ['required field'],
      term: null,
    }
  },
  computed: {
    fields () {
      return [
        {
          name: '__slot:avatar',
          width: '60px',
        }, {
          name: 'name',
          title: '姓名',
          width: '10%',
        },
        {
          name: '__slot:sort',
          title: '排序',
          width: '10%',
        },
        {
          name: '__slot:enterpriseLogo',
          width: '60px',
        },
        {
          name: 'position',
          title: '企业',
          width: '10%',
        },
        {
          name: 'experience',
          title: '经历',
          width: '40%',
        },
        {
          name: '__slot:actions',
          width: '10%',
          dataClass: 'text-left',
        },
      ]
    },
    filteredData () {
      if (!this.term || this.term.length < 1) {
        return this.items
      }
      return this.items.filter(item => {
        return item.name.toLowerCase().startsWith(this.term.toLowerCase())
      })
    },
  },
  created () {
    this.listMentor()
  },
  methods: {
    listMentor (pageNumber = 1) {
      this.loading = true
      const params = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
      }
      mentorApi.listMentor(params)
        .then(response => {
          this.items = response.mentors
          this.totalPages = response.totalPage
          this.loading = false
        })
    },
    confirmUpdateMentor () {
      mentorApi.updateMentor(this.updateData.id, {
        name: this.updateData.name,
        avatar: this.updateData.avatar,
        position: this.updateData.position,
        enterpriseLogo: this.updateData.enterpriseLogo,
        experience: this.updateData.experience,
        active: this.updateData.active,
        strength: this.updateData.strength,
        sortNum: this.updateData.sortNum,
      }).then(response => {
        console.log(response)
        if (response.success === true) {
          this.listMentor()
        } else {
        }
      }).catch(error => {
        console.log(error)
      })
    },
    cancelUpdateMentor () {
      this.updateData = {}
    },
    confirmDeleteMentor () {
      mentorApi.deleteMentor(this.deleteId).then(response => {
        console.log(response)
        if (response.success === true) {
          this.listMentor()
        }
      })
    },
    uploadEnterpriseLogo () {
      if (this.updateData.enterpriseLogoFile.length === 0) return
      const formData = new FormData()
      formData.append('type', 'IMAGE')
      formData.append('file', this.updateData.enterpriseLogoFile[this.updateData.enterpriseLogoFile.length - 1])
      // 保存avatar图片
      uploadApi.uploadImage(formData).then(response => {
        console.log(response)
        this.updateData.enterpriseLogo = response.url
      })
    },
    search: debounce(function (term) {
      this.term = term
    }, 400),
    updateSortNum: function (params) {
      mentorApi.updateMentor(params.id, params).then(response => {
        if (response.success === true) {
          this.listMentor()
        }
      }).catch(error => alert(error))
    },
  },
}
</script>
<style lang="scss">
.data-table-server-pagination---avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}

.va-card-image image {
  position: absolute;
  top: 50%;
  left: 50%;
  display: block;
  min-width: 100%;
  min-height: 100%;
}
</style>
